module.exports = __webpack_public_path__ + "static/media/reh.15ac3e66.mp4";